/* eslint-disable no-unused-vars */
import React from 'react';
import {
  Page,
  Section,
  Row,
  Cell,
  Seperator,
  Column,
  Label,
} from '@src/components/Layout';

const Dashboard = () => {
  return (
    <Page title="Dashboard">
      <Section>
        <h1>Dashboard</h1>
        <Label italic>Ikke implementert</Label>
        <Seperator />
      </Section>
    </Page>
  );
};

export default Dashboard;

Dashboard.propTypes = {};
